import React from "react";
import styled from "styled-components";

export const PriceHeader = styled.div`
    display: flex;
    justify-content: flex-end;
    text-transform: none;
    font-weight: normal;
    font-size: 11px;
`;

const PriceContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const PriceCell = styled.div`
    font-size: 12px;
    margin-right: 4px;
`;

const PriceCurrencyCell = styled.div`
    font-size: 12px;
`;

const format = (value) => {
    return Number(Number(value).toFixed(2)).toLocaleString(navigator.language, {minimumFractionDigits: 2});
};

export const Price = ({price, currency, className}) => {
    return <PriceContainer className={className}>
        <PriceCell className="t-amount">
            {price === null ? "\u2014" : format(price)}
        </PriceCell>
        <PriceCurrencyCell className="t-stock-currency">
            {price === null ? "" : currency}
        </PriceCurrencyCell>
    </PriceContainer>
};
